import Country from '~/Api/Country/Country';

export default class ReferenceBasketVersion {
	constructor(
		public readonly id: string,
		public readonly sinceDate: Date,
		public readonly description?: string,
		public readonly referencedCountry?: Country,
		public readonly referenceCountries?: Country[]
	) {}
}
